<template>
  <div>
    <BookingReportBudgetUtilizationAddEditComponent />
  </div>
</template>

<script>
import BookingReportBudgetUtilizationAddEditComponent from "../../../components/Booking/Report/BookingReportBudgetUtilizationAddEditComponent";
export default {
  name: "BookingReportBudgetUtilizationNewView",
  components: { BookingReportBudgetUtilizationAddEditComponent }
};
</script>

<style scoped></style>
